// Anchored on `Eq` so hyphens inside a substance name (`kg CFC-11-Eq`) are left alone.
const EQ_SUFFIX = /-Eq\b/g;

export const formatLciaUnit = (unit: string): string => unit.replace(EQ_SUFFIX, ' - Eq');
